import {
  updateFence,
  updateFenceById
} from '../../../../../common/redux/reducer/commonSlices/circleSlice';
import { map } from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import {
  updateIsShowDrawingManager,
  updatePolygonFences
} from '../../../../../common/redux/reducer/commonSlices/polygonSlice';

export const useGeofenceRadioFunc = ({
  setValue,
  getValues,
  clearErrors,
  setIsCircular,
  setAddress,
  polygonFences,
  fences,
  dispatch
}: any) => {
  const handleGeoTypeChange = (e: any) => {
    dispatch(map([]));
    setValue('location', null);
    getValues('vehicle');
    setValue('geoType', e.target.value);
    clearErrors();
    if (e.target.value === 'circular') {
      setIsCircular(true);
      setAddress(null);
      setValue('radius', '');
      dispatch(updateIsShowDrawingManager(false));
      const polygon = polygonFences?.filter((item: any) => item?.id !== 'new');
      dispatch(updatePolygonFences(polygon));
    } else {
      setIsCircular(false);
      let circular = fences?.filter((item: any) => item?.id !== 'new');
      dispatch(updateFence(circular));
      dispatch(updateIsShowDrawingManager(true));
    }
  };
  return { handleGeoTypeChange };
};

export const useGeofenceLocationFunc = ({
  resetField,
  setAddress,
  dispatch,
  filteredRow,
  fences
}: any) => {
  const handleLocationChange = (e: any) => {
    if (!e.target.value) {
      resetField('location');
      setAddress(null);
      if (!filteredRow) {
        const filteredCircles = fences?.filter((item: any) => item?.id !== 'new');
        dispatch(updateFence(filteredCircles));
        dispatch(map([]));
      } else {
        const filteredCircles = fences?.filter(
          (item: any) => item?.id !== filteredRow?.geoZoneId && item?.id !== 'new'
        );
        dispatch(map([]));
        dispatch(updateFence(filteredCircles));
      }
    }
  };
  return { handleLocationChange };
};

export const useGeofenceRadiusFunc = ({
  setValue,
  trigger,
  getValues,
  setError,
  filteredRow,
  fences,
  dispatch
}: any) => {
  const handleRadiusChange = (e: any) => {
    const radius = parseFloat(e);
    setValue('radius', e);
    trigger('radius');
    if (!getValues('location')) {
      setError('location', { message: 'Enter a Location' });
      return;
    }

    if (filteredRow) {
      let [selectedFence]: any = fences?.filter(
        (item: any) => item?.id === filteredRow?.geoZoneId || item?.id === 'new'
      );
      dispatch(
        updateFenceById({
          id: selectedFence?.id,
          center: selectedFence?.center,
          radius: radius ? radius * 1000 : !radius ? 1000 : selectedFence?.radius
        })
      );
    } else {
      const [newOne]: any = fences?.filter((item: any) => item?.id === 'new');
      dispatch(
        updateFenceById({
          id: newOne?.id,
          center: newOne?.center,
          radius: radius ? radius * 1000 : 1000
        })
      );
    }
  };
  return { handleRadiusChange };
};
